<template>
main
  <a @click="get">GET</a>
  <br>
  {{sessid}}
  <br>
  {{data}}
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
    data: () => ({
      data: null
    }),
  computed: {
    ...mapGetters([
      'sessid'
    ]),
    shareSupported() {
      return navigator.share
    }
  },
  methods: {
      async get() {
        const response = await this.axios.get('/api/user/profile/');
        this.data = response.data
      }
  }
}
</script>
